import axios from 'axios';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ProjectConfig } from 'Global';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';
import 'assets/css/main.css';
import ParentProductsEditor from './ParentProductsEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function ParentProductsList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => { setLoading(false); }, []);

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => { loadList(); }, [page]);

  const loadList = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/product_parents/list",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { page },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      },
    });
  };

  const handleDelete = (id: number) => {
    setActiveItem(id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    axios.post(ProjectConfig.api_url + "/product_parents/deleteItem", { parent_product_id: activeItem })
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar('Producto padre eliminado', { variant: 'success' });
          loadList();
        }
      })
      .catch((err) => { console.log(err); })
      .finally(() => { setOpenAlert(false); });
  };

  return (
    <div id='ParentProductsList' className='ModuleContainer'>
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Productos Padre</h2>
            <span className="h2_subtitle">Lista de productos padre</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => { setActiveItem(null); setOpenEditor(true); }}
              startIcon={<AddIcon />}
            >
              Crear producto padre
            </Button>
          </div>
        </div>

        <Box id='ParentProductsListIn' className='box100'>
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>NOMBRE</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>CÓDIGO</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover>
                    <TableCell>{item.parent_product_name}</TableCell>
                    <TableCell>{item.parent_product_code}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => { setActiveItem(item.parent_product_id); setOpenEditor(true); }}
                      >
                        Editar
                      </Button>
                      {(localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2") &&
                        <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.parent_product_id)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar este producto padre?"
        send={deleteItem}
      />

      <ParentProductsEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        parent_product_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
}
